import { Typography } from '@mui/material';
import { FC } from 'react';
import { List, RowComponentProps } from 'react-window';

import { User, UserMin } from '@apiContract';

import Item, { BadgeProp } from './item';

type SelectedObject = { [id: string]: User | UserMin };

export type BadgeList = {
  [id: string]: BadgeProp;
};

type ListProps = {
  height: number;
  width: number;
  users: (User | UserMin)[];
  onClick?: (user: User | UserMin) => void;
  selected?: SelectedObject;
  blocked?: string[];
  badges?: BadgeList;
  useTitle?: boolean;
  blockedTitle?: string;
};

type ItemProps = {
  data: {
    total: number;
    users: (User | UserMin)[];
    blocked?: string[];
    onClick?: (user: User | UserMin) => void;
    selected?: SelectedObject;
    badges?: BadgeList;
    useTitle?: boolean;
    blockedTitle?: string;
  };
};

const UserItem = ({ style, index, data }: RowComponentProps<ItemProps>) => {
  if (data.total === 0) return <Typography variant="body2">No results found</Typography>;
  const userId = data.users[index].id;
  const isBlocked = data.blocked && data.blocked.includes(userId);
  return (
    <>
      {!!data.total && (
        <Item
          badge={(!!data.badges && data.badges[userId]) || undefined}
          style={style}
          item={data.users[index]}
          useTitle={data.useTitle}
          blocked={isBlocked}
          blockedTitle={data.blockedTitle}
          onClick={
            data.onClick
              ? () => {
                  if (data.blocked && !isBlocked && data.onClick) {
                    data.onClick(data.users[index]);
                  }
                }
              : undefined
          }
          selected={Boolean(!!data.selected && data.selected[userId])}
        />
      )}
    </>
  );
};

const UserList: FC<ListProps> = ({
  height,
  width,
  users,
  onClick,
  selected,
  blocked,
  badges,
  useTitle,
  blockedTitle,
}) => (
  <List
    rowCount={users.length || 1}
    rowHeight={68}
    className="customScrollBar"
    style={{ height, width }}
    rowProps={{
      data: {
        users: users,
        onClick,
        total: users.length,
        selected,
        blocked,
        badges,
        useTitle,
        blockedTitle,
      },
    }}
    rowComponent={UserItem}
  />
);

export default UserList;
